export default "__VITE_ASSET__COwqg_26__"